import { useQuery } from '@tanstack/react-query'
import { getOrganizationStats } from '@/api/organizationApi'
import { useAuthStore } from '@/store/authStore'

/**
 * Hook to fetch organization stats including usage and limits from database.
 * Every user always has an organization; selectedOrganizationId is null only during initial load.
 */
export function useOrganizationStats() {
  const selectedOrganizationId = useAuthStore((state) => state.selectedOrganizationId)

  return useQuery({
    queryKey: ['organization-stats', selectedOrganizationId],
    queryFn: () => getOrganizationStats(selectedOrganizationId as string),
    enabled: !!selectedOrganizationId,
    staleTime: 30 * 1000, // 30 seconds - stats change frequently
  })
}
